import { useEffect } from "react"
import useRegister from "../../context/register"
import { usePageTitle } from "../../hooks"
import { Steps } from "./steps"
import { useLocation, useNavigate } from "react-router-dom"


export const Register = ({ isClient = true }: { isClient?: boolean }) => {
    usePageTitle("Cadastro")

    const navigate = useNavigate()
    const { state } = useLocation()
    const { step } = useRegister()

    const StepComponent = Steps[step]

    useEffect(() => {
        if (!state?.verified && isClient) navigate(-1)
    }, [])


    if (!StepComponent) {
        return <div>Etapa não encontrada!</div>;
    }

    return (
        <StepComponent isClient={isClient} />
    )
}